//@flow
import React from "react"
import { Switch, Route } from "react-router-dom"
import SlideListView from "./SlideListView"
import SlideFormView from "./SlideFormView"
import type { Match } from "react-router-dom"
import queries from "./queries"

const Slides = (attractLoopId: string) => ({ match }: { match: Match }) => {
  return (
    <Switch>
      <Route
        path={`${match.url}/new`}
        render={props =>
          <SlideFormView {...props} attractLoopId={attractLoopId} />}
      />
      <Route
        path={`${match.url}/:id`}
        render={props =>
          <SlideFormView {...props} attractLoopId={attractLoopId} />}
      />
      <Route
        render={props =>
          <SlideListView {...props} attractLoopId={attractLoopId} />}
      />
    </Switch>
  )
}

export { queries }

export default Slides



// WEBPACK FOOTER //
// ./src/Slides/index.js